import { GrainOverlay } from '@/components/design-system';
import { PageLayout } from '@/components/poof-ui';
import Nav from '@/components/layout/Nav';
import type { ReactNode } from 'react';

interface PageShellProps {
  children: ReactNode;
  footer?: ReactNode | false;
}

/** Shared shell for every route: grain texture + sticky nav + PageLayout, with bottom padding for the mobile tab bar. */
export function PageShell({ children, footer }: PageShellProps) {
  return (
    <>
      <GrainOverlay />
      <Nav />
      <PageLayout fullBleed footer={footer}>
        <div className='pt-20 pb-24 md:pb-0'>{children}</div>
      </PageLayout>
    </>
  );
}

export default PageShell;
